import * as products from './list'

import { Product } from 'app/types/catalogue/product'

export const allProducts: Product[] = Object.values(products).sort(
    (previous, current) => previous.name.localeCompare(current.name),
)
